"use client";
import Slider from "react-slick";

const settings = {
  autoplay: true,
  autoplaySpeed: 3000,
  dots: true,
  fade: false,
  arrows: false,
  infinite: true,
  speed: 700,
  slidesToShow: 1,
  slidesToScroll: 1,
};

type IProps = {
  banners?: any[];
};

const HeroSliderOne = ({ banners = [] }: IProps) => {
  return (
    <section className="slider__area">
      <style>{`
        .slider__area {
          width: 100%;
          overflow: hidden;
        }

        .hero-slide-wrapper {
          width: 100%;
          overflow: hidden;
        }

        /* Desktop: natural size এ দেখাবে, কিন্তু 500px এর বেশি হবে না */
        .hero-slide-img {
          width: 100%;
          height: auto;
          display: block;
          max-height: 500px;
          object-fit: cover;
          object-position: center center;
        }

        /* Mobile */
        @media (max-width: 767px) {
          .hero-slide-img {
            max-height: 220px;
          }
        }

        .slider__area .slick-dots {
          bottom: 12px;
        }
        .slider__area .slick-dots li button:before {
          color: #fff;
          font-size: 10px;
          opacity: 0.6;
        }
        .slider__area .slick-dots li.slick-active button:before {
          opacity: 1;
          color: #fff;
        }
      `}</style>

      <Slider {...settings}>
        {banners.map((slider, index) => (
          <div key={index} className="hero-slide-wrapper">
            <img
              src={slider?.image}
              alt={`banner-${index}`}
              className="hero-slide-img"
            />
          </div>
        ))}
      </Slider>
    </section>
  );
};

export default HeroSliderOne;